export const config = Object.freeze({
    apiURL: process.env.REACT_APP_API_URL || "http://localhost:3000/api",
});
